module.exports = __webpack_public_path__ + "kerbin/app/images/brands/maternity-neighborhood-logo.96efc859.png";